import { Card, CardContent } from '@/components/ui/card';
import { Clock, Info } from 'lucide-react';

export function DepositUnavailable() {
  return (
    <div className="space-y-4">
      <Card className="bg-muted/50 border-muted">
        <CardContent className="py-10 text-center space-y-4">
          <div className="mx-auto w-16 h-16 rounded-full bg-muted flex items-center justify-center">
            <Clock className="h-8 w-8 text-muted-foreground" />
          </div>
          <div className="space-y-2">
            <h3 className="font-semibold text-lg">Deposits Temporarily Unavailable</h3>
            <p className="text-sm text-muted-foreground max-w-xs mx-auto">
              Our deposit system is currently being configured. Please check back later.
            </p>
          </div>
        </CardContent>
      </Card>

      <div className="flex items-center gap-2 text-xs text-muted-foreground bg-muted/30 rounded-lg p-3">
        <Info className="h-4 w-4 shrink-0" />
        <span>If you need assistance, please contact our support team.</span>
      </div>
    </div>
  );
}
